import { ROUTESWEB } from "@repo/utils";
import { SELF_LEARN_ROUTES } from "@repo/self-learn-web";
import type { ModuleHandler } from "../types";

export const selfLearnHandler: ModuleHandler = (parsed, navigate) => {
  const allParams = parsed.allParams || {};
  const {
    subjectId,
    chapterId,
    bookId,
    videoId,
    storyId,
    insideBookChapterId,
  } = allParams;

  const query = new URLSearchParams(allParams);
  query.delete("module");
  query.delete("isFromDeepLinking");
  const search = query.toString() ? `?${query.toString()}` : "";

  // 1. Direct Video Landing
  if (videoId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // 2. Textbook Solution - Specific Chapter
  if (insideBookChapterId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // 3. Textbook Solution - Book Landing
  if (bookId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // 4. Interactive Story Landing
  if (storyId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // 5. Chapter Details (Learn/Practice/Revise tabs)
  if (chapterId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // 6. Chapter List (Subject Landing)
  if (subjectId) {
    const finalPath = `/${ROUTESWEB.APP.SELF_LEARN}/${SELF_LEARN_ROUTES.CHAPTERLIST}${search}`;
    navigate(finalPath, { replace: true });
    return;
  }

  // Default: Self Learn Homepage
  return {
    path: `/${ROUTESWEB.APP.SELF_LEARN}${search}`,
  };
};
